var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('gmap-map',{staticStyle:{"width":"100%","height":"340px"},attrs:{"center":_vm.centers,"zoom":11,"map-type-id":"terrain"}},[_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position}})}),_vm._l((_vm.markers),function(m,index){return _c('GmapCircle',{key:index,attrs:{"center":m.position,"radius":4000,"options":{
        strokeColor: '#057de7', //线颜色
        strokeOpacity: 0.2, //线透明度
        strokeWeight: 2, //线粗细度
        fillColor: '#1791fc' //填充颜色
      }}})})],2),_c('van-button',{on:{"click":_vm.reverseGeocode}},[_vm._v("test")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }